var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalBase',{attrs:{"name":"selectMortgageModal","size":"large","clickToClose":false,"showClose":true,"title":"Select Mortgage","position":"center"}},[_c('mortgage-list-view',{attrs:{"showOther":_vm.showOther},on:{"tableRowClicked":function($event){return _vm.$emit('tableRowClicked', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }